import { evvToken } from '../constants';
import { setInStorage } from '../utils';

function HttpError(status, text, message) {
  this.status = status;
  this.text = text;
  this.message = message;
}

const getJSONResponse = async response => {
  try {
    return await response.json();
  } catch (error) {
    return {};
  }
};

const fetchRequest = async (url, request) => {
  const response = await fetch(url, request);
  if (!response.ok) {
    const message = await getJSONResponse(response);
    if (response.status === 401) setInStorage(evvToken, '');

    throw new HttpError(response.status, response.statusText, message);
  }

  const contentType = response.headers.get('Content-Type');

  if (contentType.includes('application/json')) {
    return getJSONResponse(response);
  }

  return response.text();
};

export default fetchRequest;
